import { useSendUserEvent } from "@/hooks/user-event/useSendUserEvent";
import { useAppDispatch } from "@/store";
import { setConfluencePageId } from "@/store/slices/documentation.slice";
import { isNumber } from "radash";

export const useOpenDocumentation = () => {
    const dispatch = useAppDispatch();
    const sendUserEvent = useSendUserEvent();

    const openDocumentation = (args: { pageId: number; title: string }) => {
        const { pageId, title } = args;

        if (!isNumber(pageId)) return;

        dispatch(setConfluencePageId(pageId));

        sendUserEvent({
            type: "click:documentation",
            value: title,
        });
    };

    return { openDocumentation };
};
